import { CardComponentProps } from "@~/types/types";
import { QuickViewIcon } from "@~/product-card-components/QuickView/components/QuickViewIcon.tsx";
import { QuickViewButton } from "@~/product-card-components/QuickView/components/QuickViewButton.tsx";
import { isEligibleForQuickView } from "../../utils/product.ts";
import { sendMonetateEvent } from "@~/utils/sendMonetateEvent.ts";

export function QuickView({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) {
  if (!isEligibleForQuickView(product)) {
    return null;
  }

  const displayOption: "button" | "icon" =
    configProps?.display === "button" ? "button" : "icon";

  const qvConfig = configProps?.qvConfig;
  const showOnHoverOnly = configProps?.showOnHoverOnly === true;

  const handleQuickViewClick = () => {
    if (typeof window?.performance?.mark === "function") {
      performance.mark("quickViewDisplayed-start");
    }
  };

  return (
    <div
      data-component="pcl-QuickView"
      onClick={() => {
        sendMonetateEvent("productCard.quickViewIcon.interaction");
      }}
    >
      {displayOption === "icon" ? (
        <QuickViewIcon
          product={product}
          handleIconClick={handleQuickViewClick}
          config={qvConfig as string | undefined}
          showOnHoverOnly={showOnHoverOnly}
        />
      ) : (
        <QuickViewButton
          product={product}
          handleButtonClick={handleQuickViewClick}
          config={qvConfig as string | undefined}
        />
      )}
    </div>
  );
}
